<img class="h-1/2 w-1/2 object-contain" [src]="iconPath()" />
